module.exports = __webpack_public_path__ + "static/img/equipment.8d7a78f7.jpg";